import TableWithFilter from 'components/InternalRequest/Summary/tableWithFilter'

export default function Pending() {
  return <TableWithFilter pageInset={205} retainFilter={true} tab={'pending'} />
}
